"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    assertNoPathParams: function() {
        return assertNoPathParams;
    },
    buildParametricRootRelativeUrl: function() {
        return buildParametricRootRelativeUrl;
    },
    buildParametricUrl: function() {
        return buildParametricUrl;
    },
    buildQuerystring: function() {
        return buildQuerystring;
    },
    buildRelativeUrl: function() {
        return buildRelativeUrl;
    },
    combinePaths: function() {
        return combinePaths;
    },
    getUrlParam: function() {
        return getUrlParam;
    },
    removeLeadingSlash: function() {
        return removeLeadingSlash;
    },
    removeTrailingSlash: function() {
        return removeTrailingSlash;
    },
    replacePathParams: function() {
        return replacePathParams;
    }
});
const _array = require("./array");
const _validation = require("./validation");
function combinePaths(base, ...pathParts) {
    const parts = [
        base,
        ...pathParts
    ];
    const path = parts.map((part)=>(0, _validation.isDefinedAndNonEmpty)(part) ? removeLeadingSlash(removeTrailingSlash(part)) : undefined).filter((p)=>!!p).join('/');
    if (base == null ? void 0 : base.startsWith('/')) {
        return '/' + path;
    }
    return path;
}
function buildParametricRootRelativeUrl(path, paramsAndQuery) {
    path = path.startsWith('/') ? path : `/${path}`;
    // eslint-disable-next-line prefer-const
    let { path: replacedPath, unusedParams } = replacePathParams(path, paramsAndQuery);
    assertNoPathParams(replacedPath);
    return buildRelativeUrl(replacedPath, unusedParams);
}
function buildParametricUrl(host, path, paramsAndQuery) {
    (0, _validation.assertIsNonEmptyString)(host);
    const pathAndQuery = buildParametricRootRelativeUrl(path, paramsAndQuery);
    return combinePaths(host, pathAndQuery);
}
const parametricPathPart = /:([^:(/)]+)(?:\([^)/]+\))?/gi;
function replacePathParams(path, params) {
    // this should probably technically be the opposite of
    // the fastify param deserialization logic, but its not.
    (0, _validation.assertIsNonEmptyString)(path);
    if (!(0, _validation.isDefined)(params)) return {
        path,
        unusedParams: params
    };
    const colonIndex = path.indexOf(':');
    if (colonIndex < 0) return {
        path,
        unusedParams: params
    };
    const replacedPath = path.replaceAll(parametricPathPart, (original, paramName)=>{
        if (paramName.endsWith('?')) {
            paramName = paramName.slice(0, -1);
            if (!(0, _validation.isDefined)(params[paramName])) {
                return '';
            }
        }
        const value = params[paramName];
        delete params[paramName];
        if (!(0, _validation.isDefined)(value)) {
            return original;
        }
        // TODO: this should throw if the matched part is a regex
        // and the value doesn't conform to the provided regex
        // EncodeURI to account for edge-cases such as a param with value `foo/bar/baz`
        return encodeURIComponent(value.toString());
    }).replace('*', '');
    return {
        path: replacedPath,
        unusedParams: params
    };
}
function assertNoPathParams(value, errorMessage) {
    const matches = [
        ...value.matchAll(parametricPathPart)
    ];
    if (matches.length) {
        const params = matches.map(([_, group])=>group).join(', ');
        (0, _validation.throwValidationError)(errorMessage != null ? errorMessage : `The value must not have parameterized path parts. Parameters ${params} exist`);
    }
}
function buildRelativeUrl(pathname, query) {
    let url = pathname || '';
    const querystring = buildQuerystring(query);
    if (querystring) {
        url += querystring;
    }
    return url;
}
function buildQuerystring(querystring) {
    if (!querystring) return '';
    // this should probably technically be the opposite of
    // the fastify qs deserialization, but its not quite.
    // there are too many options with avj that can control deserialization
    const keys = Object.keys(querystring).filter((k)=>(0, _validation.isDefined)(querystring[k])).sort((a, b)=>a.localeCompare(b));
    const pairs = keys.map((key)=>{
        const value = querystring[key];
        // handle arrays in a way that fastify can reconstitute them
        if (Array.isArray(value)) {
            return value.map((x)=>`${key}=${encodeURIComponent(x)}`).join('&');
        }
        // working code, but currently we are not requiring this kind of transformation
        // if (typeof value === 'object') {
        //   const processSubKeys = (
        //     data: Record<string, any>,
        //     rootKey: string
        //   ): string => {
        //     const subKeys = Object.keys(data).filter((k) => isDefined(data[k]));
        //     const subPairs = subKeys.map((subKey) => {
        //       const subValue = value[subKey];
        //       if (typeof subValue === 'object') {
        //         return processSubKeys(subValue, `${rootKey}.${subKey}`);
        //       }
        //       return `${rootKey}.${subKey}=${encodeURIComponent(subValue)}`;
        //     });
        //     return subPairs.filter((subPair) => !!subPair).join('&');
        //   };
        //
        //   return processSubKeys(value, key);
        // }
        return `${key}=${encodeURIComponent(value)}`;
    });
    const qs = pairs.filter((pair)=>!!pair).join('&');
    return qs ? '?' + qs : qs;
}
function removeLeadingSlash(input) {
    if (!input) return input;
    if (!input.startsWith('/')) {
        return input;
    }
    return input.slice(1);
}
function removeTrailingSlash(input) {
    if (!input) return input;
    if (!input.endsWith('/')) {
        return input;
    }
    return input.slice(0, -1);
}
function getUrlParam(input) {
    if (!input) return undefined;
    return Array.isArray(input) ? (0, _array.mustGetFirstElement)(input) : input;
}

//# sourceMappingURL=url.js.map